import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import uid from 'uid';
import { orderCollection, orderCollectionPostDelete } from 'utils/ordering';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import * as actions from 'funnel/actions/answer';

const getInitialState = {};

const answersByQuestion = (state, question) =>
  state.items.filter(i => i.question.toString() === question.toString());

function reorderAnswers(state, answer, thunk) {
  const toUpdate = state.items.get(answer.id.toString());
  if (toUpdate) {
    return {
      ...state,
      items: orderCollection(
        state.items,
        answer.id,
        toUpdate.order,
        thunk(toUpdate.order),
        a => a.question.toString() === answer.question.toString()
      ),
    };
  }

  return state;
}

const answers = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel }) {
    const { steps } = funnel;
    const answers = steps.map(s => s.answers).reduce((a, b) => a.concat(b), []);

    return {
      ...state,
      items: Map(keyBy(answers, 'id')),
    };
  },
  [actions.CREATE_ANSWER](state, { question, fields }) {
    const answer = {
      id: uid(),
      new: true,
      question,
      order: answersByQuestion(state, question).size + 1,
      imagePartId: fields.image ? uid() : undefined,
      ...fields,
    };

    return {
      ...state,
      items: state.items.set(answer.id, answer),
    };
  },
  [actions.UPDATE_ANSWER](state, { id, answer }) {
    return {
      ...state,
      items: state.items.update(id.toString(), existing => {
        return {
          imagePartId: answer.image_id ? undefined : uid(),
          ...existing,
          ...answer,
        };
      }),
    };
  },
  [actions.MOVE_ANSWER_UP](state, { answer }) {
    return reorderAnswers(state, answer, order => order - 1);
  },
  [actions.MOVE_ANSWER_DOWN](state, { answer }) {
    return reorderAnswers(state, answer, order => order + 1);
  },
  [actions.DELETE_ANSWER](state, { answer }) {
    return {
      ...state,
      items: orderCollectionPostDelete(
        state.items.remove(answer.id.toString()),
        answer.order
      ),
    };
  },
});

export default answers;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/answers.js